import { EPSurveyWrapper } from './EPSurveyWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UITextInput from 'UIComponents/input/UITextInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UIButton from 'UIComponents/button/UIButton';
import styled from 'styled-components';
import { EERIE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackTextWrapper = styled.div.withConfig({
  displayName: "EPSurveyForm__FeedbackTextWrapper",
  componentId: "sc-7gud6b-0"
})(["width:67%;"]);
const defaultTitle = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
  message: "epAmplitudeSurvey.feedback.form.title"
});
export const EPSurveyForm = ({
  closeFeedbackBadge,
  updateFeedbackMessage,
  feedbackMessage,
  submitFeedback,
  title = defaultTitle
}) => {
  return /*#__PURE__*/_jsx(EPSurveyWrapper, {
    children: /*#__PURE__*/_jsxs(UICardWrapper, {
      compact: true,
      children: [/*#__PURE__*/_jsx(UICardSection, {
        className: "p-bottom-2",
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          justify: "between",
          children: [title, /*#__PURE__*/_jsx(UICloseButton, {
            color: EERIE,
            onClick: () => closeFeedbackBadge(),
            size: "medium"
          })]
        })
      }), /*#__PURE__*/_jsx(UICardSection, {
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          justify: "between",
          children: [/*#__PURE__*/_jsx(FeedbackTextWrapper, {
            children: /*#__PURE__*/_jsx(UITextInput, {
              "aria-label": "feedback-form",
              onChange: updateFeedbackMessage
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            className: "m-left-2",
            disabled: !feedbackMessage,
            onClick: submitFeedback,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "epAmplitudeSurvey.feedback.form.submit"
            })
          })]
        })
      })]
    })
  });
};
export default EPSurveyForm;